import React from "react"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Link } from "react-router-dom"
import { MDBDataTable } from "mdbreact"
import { Row, Col, CardBody, Card, Container, Button } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const Reviews = props => {
  const data = {
    columns: [
      {
        label: "Customer Name",
        field: "CustomerName",
        sort: "asc",
        attributes: { width: "15%" },
      },
      {
        label: "Mobile Number",
        field: "MobileNumber",
        sort: "asc",
        attributes: { width: "12%" },
      },
      {
        label: "Order No",
        field: "OrderNo",
        sort: "asc",
        attributes: { width: "8%" },
      },
      {
        label: "Date Time",
        field: "DateTime",
        sort: "asc",
        attributes: { width: "17%" },
      },
      {
        label: "Rating",
        field: "Rate",
        sort: "asc",
        attributes: { width: "11%" },
      },
      {
        label: "Description",
        field: "Description",
        sort: "asc",
        attributes: { width: "37%" },
      },
      
    ],
    rows: [
      {
        CustomerName: "Yana Suthar",
        MobileNumber: "9638869115",
        OrderNo: "#6765767",
        DateTime: "11/04/2022 | 02:55 PM",
        Description: "Purus, in hendrerit nisl molestie lectus turpis lorem donec. Lorem consectetur quis tincidunt.",
        Rate: (
          <>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star-half-alt"></i>
          </>
        ),
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Review")} | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Customer Reviews List ")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    responsive
                    bordered
                    noBottomColumns
                    theadColor={"btn-primary"}
                    data={data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
Reviews.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(Reviews))
